import { Type , type , union , literal, string } from 'io-ts';

import { NonEmpty } from '~/src/base/Array/NonEmpty';
import { Figure } from '~/src/figure';

import { Page , Config } from '~/src/tweaker/Figure/State';

// Incoming Messages

export interface MsgLoadFigure {
	tag : 'MsgLoadFigure';
	fig : Figure;
}

export const MsgLoadFigure : Type< MsgLoadFigure > = type( {
	tag : literal( 'MsgLoadFigure' ) ,
	fig : Figure,
} );

export interface MsgFocusFigure {
	tag : 'MsgFocusFigure';
}

export const MsgFocusFigure : Type< MsgFocusFigure > = type( {
	tag : literal( 'MsgFocusFigure' ),
} );

export interface MsgDownloadFigure {
	tag : 'MsgDownloadFigure';
}

export const MsgDownloadFigure : Type< MsgDownloadFigure > = type( {
	tag : literal( 'MsgDownloadFigure' ),
} );

export interface MsgGetPages {
	tag : 'MsgGetPages';
}

export const MsgGetPages : Type< MsgGetPages > = type( {
	tag : literal( 'MsgGetPages' ),
} );

export interface MsgSetActive {
	tag : 'MsgSetActive',
	act : string,
}

export const MsgSetActive : Type< MsgSetActive > = type( {
	tag : literal( 'MsgSetActive' ),
	act : string,
} );

export interface MsgResetTweaks {
	tag : 'MsgResetTweaks';
}

export const MsgResetTweaks : Type< MsgResetTweaks > = type( {
	tag : literal( 'MsgResetTweaks' ),
} );

export interface MsgConfig {
	tag : 'MsgConfig';
	con : Config;
}

export const MsgConfig : Type< MsgConfig > = type( {
	tag : literal( 'MsgConfig' ),
	con : Config,
} );


export type Message
	= MsgLoadFigure
	| MsgFocusFigure
	| MsgDownloadFigure
	| MsgGetPages
	| MsgSetActive
	| MsgResetTweaks
	| MsgConfig
;

export const Message : Type< Message > = union(
	[ MsgLoadFigure
		, MsgFocusFigure
		, MsgDownloadFigure
		, MsgGetPages
		, MsgSetActive
		, MsgResetTweaks
		, MsgConfig
	]
);


// Outgoing Messages

export interface ResFigure {
	tag : 'ResFigure';
	fig : Figure;
}

export const resFigure = ( fig : Figure ) : ResFigure =>
	({ tag : 'ResFigure' , fig } );


export interface ResPages {
	tag : 'ResPages';
	pgs : NonEmpty< Page >;
}

export const resPages = ( pgs : NonEmpty< Page > ) : ResPages =>
	({ tag : 'ResPages' , pgs });


